import { CARD_TYPE_MAP } from '../cardTypes';

const CARD_TYPES_WITH_QR_CODE_ON_BACK = [
  CARD_TYPE_MAP.std,
  CARD_TYPE_MAP.invitation,
  CARD_TYPE_MAP.enclosure,
  CARD_TYPE_MAP.details,
  CARD_TYPE_MAP.weddingShower,
] as const;

const CARD_TYPES_WITH_QR_CODE_ON_FRONT = [
  CARD_TYPE_MAP.rsvp,
  CARD_TYPE_MAP.enclosure,
  CARD_TYPE_MAP.details,
] as const;

export type CardWithQrCodeOnBack = (typeof CARD_TYPES_WITH_QR_CODE_ON_BACK)[number];
export type CardTypeWithQrCodeOnFront = (typeof CARD_TYPES_WITH_QR_CODE_ON_FRONT)[number];
export type CardTypeWithQrCode = CardWithQrCodeOnBack & CardTypeWithQrCodeOnFront;

export const isCardWithQrCodeOnBack = (type?: string): type is CardWithQrCodeOnBack => {
  if (!type) return false;
  return (CARD_TYPES_WITH_QR_CODE_ON_BACK as Readonly<string[]>).includes(type);
};

export const isCardTypeWithQrCodeOnFront = (type?: string): type is CardTypeWithQrCodeOnFront => {
  if (!type) return false;
  return (CARD_TYPES_WITH_QR_CODE_ON_FRONT as Readonly<string[]>).includes(type);
};

export const isCardTypeWithQrCode = (type?: string): type is CardTypeWithQrCode => {
  return isCardWithQrCodeOnBack(type) || isCardTypeWithQrCodeOnFront(type);
};
